// Live's prompt templates in the image composer (spec G12-prompt-templates, #251): what the panel
// reads of a template and of the draft. Live's `prompt-templates/**` and `image-slots.ts`.
import type { Asset, PromptTemplate } from "../../../api/generated/model";

/** The draft as the panel's outline reads it: its prompt and its references' library files. */
export interface TemplateDraft {
  prompt: string;
  referenceIds: string[];
}

/** A template's reference images: the library pictures of the job it was saved from. */
export function templatePictures(template: PromptTemplate): string[] {
  return template.references.flatMap((ref) => (ref.kind === "asset" ? [ref.asset_id] : []));
}

/**
 * The template live outlines: the first listed whose prompt, trimmed, is the draft's (an empty
 * draft matches none); with references in the draft, only one with the same references, in any
 * order. Live compares their URLs; ours the files they name.
 */
export function outlinedTemplate(
  templates: PromptTemplate[],
  draft: TemplateDraft,
): PromptTemplate | undefined {
  const prompt = draft.prompt.trim();
  if (prompt === "") return undefined;
  const wanted = sameSet(draft.referenceIds);
  return templates.find(
    (each) =>
      each.prompt.trim() === prompt &&
      (draft.referenceIds.length === 0 || sameSet(templatePictures(each)) === wanted),
  );
}

function sameSet(ids: string[]): string {
  return [...ids].sort().join(" ");
}

/** A picture the composer can still take: in the library, out of the trash, and ready. */
export function usablePicture(asset: Asset): boolean {
  return asset.kind === "image" && asset.deleted_at === null && asset.status === "ready";
}
